// extracted by mini-css-extract-plugin
module.exports = {"formInput":"styles--formInput--1Wyic","bgFileInput":"styles--bgFileInput--nm0gF","uploadLabelWidth":"styles--uploadLabelWidth--3oC0R"};